import { Box, LinearProgress } from "@mui/material";
import * as React from "react";

export const MprcInfiniteLoading: React.FC<{ visible?: boolean; }> = ({ visible }) => {
    return (
        <Box sx={{ mb: "1px" }}>
            {
                visible === true
                ? <LinearProgress color="secondary" />
                : <div style={{ height: "4px" }}>&nbsp;</div>
            }
        </Box>
    );
};
